// If you want to use variables, they should not include white spaces inside like `{{var}}`
export default {
  common: {
    next: "下一步",
    back: "返回",
    close: "关闭",
    cancel: "取消",
    submit: "提交",
    hide: "不显示",
    show: "显示",
    publish: "显示产品",
    unpublish: "隐藏产品",
    done: "完成",
    ok: "OK",
    leave: "离页",
    price: "价格",
    duration: "使用期",
    stay: "留在这页",
    product: "产品",
    yes: "是",
    no: "不是",
    download: "下载",
    uploadError: "请确保您的文件是小于10MB",
    errorMessage: "对不起，系统出现了问题! 请您再试一次或联络我们的管理员!",
  },
  month: {
    January: "一月",
    February: "二月",
    March: "三月",
    April: "四月",
    May: "五月",
    June: "六月",
    July: "七月",
    August: "八月",
    September: "九月",
    October: "十月",
    November: "十一月",
    December: "十二月",
  },
  label: {
    productName: "产品名称",
    tradeTerm: "贸易方式",
    port: "港口",
    packaging: "包装",
    shipmentMonth: "装船月份",
    currency: "货币",
    unit: "计量单位",
  },
  marketProviders: {
    sourcesageTitle: "油脂和表面活性剂每日价格",
    sourcesageSubtitle: "油脂和表面活性剂",
    sourcesageBody: "棕榈油，棕榈仁油，脂肪醇，脂肪酸，十二烷基迷硫酸钠，K12",
    emptyStateTitle: "新功能即将来临！",
    emptyStateBody: "您能选择不同的信息提供者以获取价格数据做参考",
    othersTitle: "其它信息提供者",
    othersSubtitle: "油脂和表面活性剂",
    othersBody: "食油，油脂，表面活性剂，石油",
  },
  DataSearchPage: {
    banner: "https://s3-ap-southeast-1.amazonaws.com/sourcesage/images/data-upload/banner_zh.png",
    mine: "您的数据页",
    public: "选择信息供应商",
    private: "仅限私人查看",
    private_note: "（您被邀请查看以下价表）",
    placeholder: "输入产品名称查询每日市场价格",
  },
  setPrice: {
    title: "设置价格",
    sub: "请为一次使用设定使用期和价格",
    text: "向进入您的数据页的顾客收费",
    sub2: "请设置免费试用次数",
    text2: "您能利用免费试用吸引顾客进入您的数据页",
    credit: "美元", 
    hours: "小时",
    visit: "免费试用次数：",
    warn: "*每次修改时段／价格，现有的用户会在下一阶段受到影响。",
    free: "不需要设置价格，我要免费提供数据",
  },
  dataPageStepsModal: {
    title: "步骤", // followed by 01, 02 or 03
    sub1: "上载您的产品",
    text1: "上传数据前请更新产品和资料",
    sub2: "更新产品价格",
    text2: "为您的顾客提供最新更新价格",
    sub3: "每次顾客进入您的数据页，您能赚取询问价格的费用",
    text3: "您可以收取查看信息所需的费用，并从搜齐平台索取此费用。",
  },
  dataList: {
    submit: "更新更改",
    subHeader: "价格表 | 最新更新",
    tableHeader1: "产品和资料",
    tableHeader2: "价格",
    addProduct: "添加产品",
    successModalHeader: "您的价格已更新",
    errorModalHeader: "您的价格无法更新",
    delivery: "交货",
    spotPrice: "现货价格",
    preview: "预览",
    previewError: "您无法进入预览页",
    last_update: "最新更新: {{date}}",
    public_view: "所有人可见",
    private_view: "仅限私人查看",
    follower: "关注者",
    followers: "关注者",
    attachment: "ATTACHMENT",
    attach_last_update: "LAST UPDATE",
    action: "ACTION",
    remove: "REMOVE",
    rename: "RENAME",
    save: "SAVE",
    add_attachment: "ADD ATTACHMENTS +",
    update_attachment: "UPDATE ATTACHMENTS",
    max_files: "Maximum 3 pdf(s)",
    current_price: "Current Price"
  },
  dataEntry: {
    last_update: "最新更新: {{date}}",
    preview: "实时预览",
    update: "更新数据页",
    use_credit: "立即付款",
    free: "免费使用",
    free_trial: "免费试用",
    warn: "这个公众号已修改利用规约，请注意新价格和使用期",
    purchase: "购买积分",
    insufficient_title: "积分不够",
    insufficient_text: "您没有足够的积分进入数据页。请购买积分。",
    payAccess: "付 {{credit}} 美元，能让您使用 {{hour}} 小时",
    payAccessManager: "您的用户需付 {{credit}} 美元，能使用 {{hour}} 小时",
    freeAccess: "您有 {{access}} 次能免费试用",
  },
  dataView: {
    product: "产品和资料",
    price: "价格",
    change: "价格浮动",
    preview: {
      pre_public: "所有人可见",
      pre_private: "仅限私人查看",
      public: "所有人可见",
      private: "仅限邀请用户可见",
      exit: "离预览页",
      price_report: "价格表 | 最新更新： {{date}}",
    },
  },
  dataItem: {
    note: "*请填写必填空格。 请注意：这些以后不能修改",
    leave: "您要离开这一页吗？您输入的资料将被删除。请选择右上角的按键保存资料！",
    price: "价格",
    spot: "现货价格（交货日期通常在30天内）",
    future: "期货价格（交货日期超过30天）",
    price_type: "价格类型",
    price_single: "单价",
    price_range: "价格范围",
    price_max: "最高价格",
    price_min: "最低价格",
    confirmDialog: {
      title: "您确定要更改吗?",
      next: "保存更改",
      visit_fee: "订阅费:",
      visit_fee_text: "付{{credit}}美元，能让您使用{{hours}}小时",
      free_trial: "免费试用次数：",
      free_trial_text: "{{visits}} 试用次数",
      set_price: "更改订阅费",
    },
    placeholder: {
      productName: "牛脂胺桶装, 十二十四脂",
      price: "输入价格",
      port: "eg. 雅加达, 巴生, 等等.",
      shipMonth: "选择装船月份",
    },
  },
  shopUpload: {
    ProductStep1: "步骤 01: 产品的资料",
    SeriesStep1: "步骤 01: 系列的资料",
    SeriesStep2: "步骤 02: 系列的显像",
    ProductStep2: "步骤 02: 产品的显像",
    AddDisplayPic: "添加显像",
    SeriesReady: "您的系列已创建！",
    ProductReady: "您的产品已创建！",
    SeriesReadyInfoText: "搜齐用户现在可以订阅您的系列。您也可以添加报告至这个系列。",
    ProductReadyInfoText: '您的产品已被刊登！您可以更新报告的描述。您也可以到主页的 "查看业绩" 查询产品的销售额。',
    ProductPopupTitle: "您现在可以提供一个基于订阅的系列！",
    ProductPopupBody: "为您的客户上传多个订阅报告在一个系列。您可以设置用户订阅的频率和价格。",
    UploadProductText: "上传您的产品 （PDF格式）",
    UploadProductSizeLimit: "文件最大 10MB",
    UploadImage: "上传图片",
    UploadNewProduct: "上传新产品",
    UploadProduct: "上传产品",
    UploadPreview: "上传预览",
    AddExistingProduct: "添加现有的产品",
    name: "产品的名称",
    description: "描述",
    tag: "产品的标签",
    AddToSeries: "添加至订阅系列",
    isThisforSale: "这是待售的产品吗？",
    forSale: "出售",
    notForSale: "免费",
    frequency: "频率",
    price: "价格 (美元)",
    PreviewQn: "您有产品的预览文件吗？",
    EditSeries: "更新系列",
    EditProduct: "更新产品资料",
    SaveSeries: "保存系列",
    DeleteSeries: "删除系列",
    SelectProducts: "选择现有的产品以添加至",
    SelectedItems: "个产品被选",
    YourProduct: "您的产品 *",
    DeleteConfirmSeries: "您确定要删除这个系列吗?",
    DeleteConfirmProduct: "您确定要删除这个产品吗？",
    DeleteSuccessSeries: "删除成功",
    DeleteSuccessProduct: "您已成功删除您的产品！",
    EditSuccess: "更新成功",
    AddProductSuccess: "您已成功添加现有产品",
    RemoveProduct: "移除",
    RemoveProductConfirm: "您确定要移除这个产品吗？",
    SeePreview: "查看预览",
    EditPage: "更改此页",
    Leave: "您确定要离开此页？您的更改将不会被保存。",
    PricePerYear: "一年的价格",
    CannotUndo: "这个更改将无法还原",
    ChangeImage: "更换图片",
    SaveProduct: "保存产品",
    Replace: "更换",
    DeleteProduct: "删除产品",
    BuyProduct: "用 {{credit}} 美元购买",
    all: "全部",
    PurchaseSuccess: "您已用积分换取此产品/服务。我们会发邮件到您的邮箱地址。",
    InsufficientPurchase: "您的积分不够购买此产品或服务。您目前的积分数量是： {{current_balance}}",
    NoCreditCard: '您需要点击"添加付款方式"以便购买积分以换取平台上的产品或服务。',
    AddPaymentMethod: "添加付款方式",
    PurchaseCredits: "购买积分",
    Credits: "美元",
    ForSubscription: "年价 {{price}} 美元（只限于{{frequency}}订阅）",
    YourProductFile: "您的产品:",
    YourPreviewFile: "此产品的预览:",
    Price: "价格（美元）",
    Free: "免费",
    Subscribe: "Subscribe",
    Subscribed: "Subscribed",
    frequencyOptions: {
      daily: "每日",
      weekly: "每周",
      monthly: "每月",
      quarterly: "每季",
      yearly: "每年",
    },
  },
  profile: {
    dataPrice: {
      data: "数据",
      title: "设置您的数据页",
      sub: "您能上载您的公司的产品，更新价格和通知您的顾客！",
      set_up_now: "立即设置",
    },
  },
  trade: {
    trade_term: {
      CFR: "CFR",
      CIF: "CIF",
      CIP: "CIP",
      CPT: "CPT",
      DAP: "DAP",
      DAF: "DAF",
      DEQ: "DEQ",
      DES: "DES",
      DDP: "DDP",
      DDU: "DDU",
      Exworks: "Exworks",
      FAS: "FAS",
      FCA: "FCA",
      FOB: "FOB",
    },
    packaging_type: {
      Drums: "桶",
      Bags: "袋",
      Flexibags: "液袋",
      "Bulk Vessel": "散船",
      IBC: "液罐 (IBC)",
      Isotank: "集装罐",
      Carton: "箱",
      Pallet: "托盘",
      "Tanker": "Tanker"
    },
    price_currency: {
      EUR: "欧元",
      GBP: "英镑",
      RMB: "人民币",
      SGD: "新币",
      USD: "美元",
      MYR: "令吉",
      INR: "印度卢比"
    },
    unit: {
      MT: "吨",
      lb: "磅",
      gal: "加仑",
      "troy ounce": "金衡盎司",
      bbl: "桶",
      kg: "公斤",
      l: "升",
      ml: "毫升",
      FCL: "柜",
      carton: "箱",
    },
  },
  user: {
    name: "名称",
    company_name: "公司名",
  },
  channelsList: {
    tags: "全部",
    search: "搜索",
    allChannels: "全部公众号",
    noChannelFound: "对不起，目前没有您搜索的公众号",
    noSearchResult: "没有搜索结果吗？",
    noSearchResultDescription: "没有搜索结果吗？点击以上以便让我们客户服务，Amanda，知道您要什么资料！",
    loadingData: "请稍等, 您的数据正在加载",
    open: "查看",
    loadMore: "加载更多",
  },
  email: {
    subscribe: "订阅",
    lead_text: "订阅 {{channelName}} 的信息，获取更新信息，产品和服务!",
    input_placeholder: "输入电子邮件",
    error_invalid_email: "这电子邮件无效",
    error_already_subscribed: "这电子邮件已订阅.",
    success_subscribed: "您已加入 {{channelName}} 的电邮列表.",
    item_email_success: "下载产品的链接已发送到您的电子邮件",
    header: "免费下载",
    body: '我们会发送 "{{productName}}" 到您的电子邮件',
  },
};



// WEBPACK FOOTER //
// ./app/constants/translations/react-native/zh.ts